import { Minus, Plus } from 'lucide-react'
import { Button } from './button'
import { Input } from './input'

interface QuantityInputProps {
  value: number
  onChange: (value: number) => void
  min?: number
  max?: number
  className?: string
}

export function QuantityInput({
  value,
  onChange,
  min = 1,
  max = 99,
  className = '',
}: QuantityInputProps) {
  const handleIncrement = () => {
    if (max && value >= max) return
    onChange(value + 1)
  }

  const handleDecrement = () => {
    if (min && value <= min) return
    onChange(value - 1)
  }

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = parseInt(e.target.value)
    if (!isNaN(newValue) && newValue >= min && newValue <= max) {
      onChange(newValue)
    }
  }

  return (
    <div className={`flex items-center border rounded-md ${className}`}>
      <Button
        type='button'
        variant='ghost'
        size='sm'
        onClick={handleDecrement}
        disabled={value <= min}
        className='h-7 w-7 p-0 rounded-l-md hover:bg-gray-100 disabled:opacity-50'
      >
        <Minus className='h-2.5 w-2.5' />
      </Button>

      <Input
        type='number'
        min={min}
        max={max}
        value={value}
        onChange={handleInputChange}
        className='h-7 w-12 text-center border-0 rounded-none focus:ring-0 focus:border-0 text-sm'
      />

      <Button
        type='button'
        variant='ghost'
        size='sm'
        onClick={handleIncrement}
        disabled={value >= max}
        className='h-7 w-7 p-0 rounded-r-md hover:bg-gray-100 disabled:opacity-50'
      >
        <Plus className='h-2.5 w-2.5' />
      </Button>
    </div>
  )
}
